/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ flex: NonNullable<unknown> }} Profile_Days_Only_FlexInputs */

const en_us2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, you pick them during the week`)
};

const pt_br2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, você escolhe na semana`)
};

const es_419_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, los eliges durante la semana`)
};

const pt_pt2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, escolhes durante a semana`)
};

const fr_fr2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, tu les choisis dans la semaine`)
};

const de_de2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, du wählst sie während der Woche`)
};

const it_it2_profile_days_only_flex = /** @type {(inputs: Profile_Days_Only_FlexInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.flex}, li scegli durante la settimana`)
};

/**
* | output |
* | --- |
* | "{flex}, you pick them during the week" |
*
* @param {Profile_Days_Only_FlexInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_days_only_flex = /** @type {((inputs: Profile_Days_Only_FlexInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Days_Only_FlexInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_days_only_flex(inputs)
	if (locale === "es-419") return es_419_profile_days_only_flex(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_days_only_flex(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_days_only_flex(inputs)
	if (locale === "de-DE") return de_de2_profile_days_only_flex(inputs)
	if (locale === "it-IT") return it_it2_profile_days_only_flex(inputs)
	return en_us2_profile_days_only_flex(inputs)
});
export { profile_days_only_flex as "profile.days_only_flex" }